import React from 'react'
import {Alert} from '@deere/ux.uxframe-react'
export default function CustomAlert({accessibilityLabel,variant,title,name,id}){
    return (
        <Alert accessibilityLabel={accessibilityLabel} variant={variant} aria-atomic="true">
            <h5 className="uxf-alert-title" id={id} name={name}>{title}</h5>
        </Alert>
    )
}